import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { manifestoChapters } from '../utils/mockData';

const ManifestoSection = () => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <section ref={ref} className="py-24 bg-gradient-to-br from-slate-50 to-orange-50">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 
            className="text-4xl md:text-5xl font-bold text-blue-900 mb-4"
            style={{ fontFamily: '"Noto Sans Devanagari", sans-serif' }}
          >
            पंच परिवर्तन
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            राष्ट्र निर्माण के पांच स्तंभ
          </p>
        </motion.div>

        <div className="grid md:grid-cols-5 gap-6">
          {manifestoChapters.map((chapter, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ 
                y: -10,
                transition: { duration: 0.3 }
              }}
              className="group relative"
            >
              {/* Card */}
              <div className="relative h-full bg-white/70 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 border border-orange-100">
                {/* Number Badge */}
                <motion.div 
                  className="absolute -top-4 -left-4 w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl flex items-center justify-center shadow-lg"
                  whileHover={{ scale: 1.1, rotate: 5 }}
                >
                  <span className="text-white text-2xl font-bold">{chapter.number}</span>
                </motion.div>

                {/* Content */}
                <div className="mt-8 space-y-4">
                  <h3 
                    className="text-2xl font-bold text-blue-900"
                    style={{ fontFamily: '"Noto Sans Devanagari", sans-serif' }}
                  >
                    {chapter.title}
                  </h3>
                  
                  <p 
                    className="text-sm text-gray-600 leading-relaxed"
                    style={{ fontFamily: '"Noto Sans Devanagari", sans-serif' }}
                  >
                    {chapter.description}
                  </p>
                </div>

                {/* Hover Effect Gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-orange-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ManifestoSection;